"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _invitationSdk = require("@ccx-public/invitation-sdk");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CC_STORAGE_URL_ID_PREFIX_STAGE = 'https://cc-api-storage-stage.adobe.io/id/';
var CC_STORAGE_URL_ID_PREFIX_PROD = 'https://cc-api-storage.adobe.io/id/';

var useShare = function useShare(urn, apiKey, environment) {
  var imsData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var userToken = imsData.token;

  var _useState = (0, _react.useState)('unshared'),
      _useState2 = _slicedToArray(_useState, 2),
      shareStatus = _useState2[0],
      setShareStatus = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      isLoading = _useState4[0],
      setIsLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = _slicedToArray(_useState5, 2),
      ownerId = _useState6[0],
      setOwnerId = _useState6[1];

  var reconfigureShareStatus = (0, _react.useCallback)(function () {
    if (urn && apiKey && environment && userToken) {
      var env = environment === 'dev' ? 'stage' : environment;

      _invitationSdk.ShareService.configure({
        token: userToken,
        environment: env,
        apiKey: apiKey,
        apiVersion: 'V4'
      });

      var shareInstance = new _invitationSdk.ShareService();
      var resourceDomain = environment === 'stage' ? CC_STORAGE_URL_ID_PREFIX_STAGE : CC_STORAGE_URL_ID_PREFIX_PROD;

      try {
        shareInstance.get({
          resourceUrl: "".concat(resourceDomain).concat(urn)
        }).then(function (shareResponse) {
          var newShareStatus = 'unshared';
          var isPublic = false;
          var isOrgShared = false;
          var isShared = false;
          var newOwnerId;
          shareResponse.collaborators.forEach(function (val) {
            if (val.id === 'all') {
              isPublic = true;
            } else if (val.id === 'orgEverybody') {
              isOrgShared = true;
            } else if (val.role === 'owner') {
              newOwnerId = val.id;
            } else {
              isShared = true;
            }
          });

          if (isPublic) {
            newShareStatus = 'public';
          } else if (isOrgShared) {
            newShareStatus = 'orgShared';
          } else if (isShared) {
            newShareStatus = 'shared';
          }

          if (newShareStatus === 'unshared' && shareResponse.invitations.length) {
            newShareStatus = 'shared';
          }

          setOwnerId(newOwnerId);
          setShareStatus(newShareStatus);
        })["catch"](function (error) {
          console.warn('Error fetching /share. User is not owner or collaborator', error);
        })["finally"](function () {
          setIsLoading(false);
        });
      } catch (exception) {
        console.warn("Error fething share for: ".concat(urn), exception);
        setIsLoading(false);
      }
    }
  }, [urn, apiKey, environment, userToken]);
  (0, _react.useEffect)(function () {
    reconfigureShareStatus();
  }, [reconfigureShareStatus]);
  return {
    shareStatus: shareStatus,
    isLoading: isLoading,
    reconfigureShareStatus: reconfigureShareStatus,
    ownerId: ownerId
  };
};

var _default = useShare;
exports["default"] = _default;